import React from 'react';

interface PickerButtonProps {
  // 'project', 'part', 'messageType', 'phase' en 'tags' zijn de renovatieticket-pickers
  // (renovatieproject, -onderdeel, type boodschap, fase en tags/categorieën).
  mode:
    | 'label'
    | 'assignee'
    | 'building'
    | 'unit'
    | 'supplier'
    | 'reporter'
    | 'source'
    | 'project'
    | 'part'
    | 'messageType'
    | 'phase'
    | 'tags';
  ticketId: number;
  value: string | null;
  /**
   * Eigen weergave in plaats van de tekst uit `value`, bv. gekleurde chips per
   * categorie op een renovatieticket. `value` blijft nodig: dat bepaalt of de knop
   * gevuld of leeg is (en dus of de placeholder verschijnt).
   */
  display?: React.ReactNode;
  placeholder?: string;
  icon?: React.ReactNode;
  bgColor?: string;
  onClick?: () => void;
  textColor?: string;
  className?: string;
  classNames?: string;
  textClassName?: string;
  selectedTicketIds?: number[];
  onClearSelection?: () => void;
}

export const PickerButton: React.FC<PickerButtonProps> = ({
  mode,
  ticketId,
  value,
  display,
  placeholder = '',
  icon,
  bgColor = 'bg-white',
  textColor = 'text-neutral-primary',
  className = '',
  classNames = '',
  textClassName = '',
  selectedTicketIds = [],
  onClearSelection
}) => {

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    // If there are selected tickets and this ticket is not among them, clear selection first
    if (selectedTicketIds.length > 0 && !selectedTicketIds.includes(ticketId) && onClearSelection) {
      onClearSelection();
      // Small delay to ensure selection is cleared before dispatching event
      setTimeout(() => {
        const event = new CustomEvent('helpdesk-open-picker', {
          detail: { mode, ticketId }
        });
        window.dispatchEvent(event);
      }, 50);
      return;
    }
    
    const event = new CustomEvent('helpdesk-open-picker', {
      detail: { mode, ticketId }
    });
    window.dispatchEvent(event);
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full text-left px-1.5 py-1 h-full rounded-sm border text-[11px] hover:bg-neutral-primary/5 border-neutral-primary/20 ${bgColor} ${textColor} ${className} ${classNames} transition-all duration-200 ease-in-out hover:shadow-sm hover:border-moss-primary/40 focus:ring-2 focus:ring-moss-primary/20 focus:outline-hidden min-w-0`}
    >
      <div className={`flex items-center gap-1 min-w-0`}>
        {icon && (value || placeholder != '') && <span className="shrink-0 transition-transform duration-200">{icon}</span>}
        {value && display ? (
          display
        ) : (
          <span className={`truncate ${textClassName}`}>{value || placeholder}</span>
        )}
      </div>
    </button>
  );
};
